import { Stack } from '@mui/material';
import { useDefineAppLocation } from '@react-admin/ra-navigation';
import { ReactElement } from 'react';
import { CanAccess, Title } from 'react-admin';
import MerchantsOfferSummaryWidget from './Widget';

export default function MerchantsOfferSummaryPage(): ReactElement {
  useDefineAppLocation('merchants.offer_summary');

  return (
    <>
      <Title title="Merchants Offer Summary" />
      <Stack spacing={3} sx={{ mt: 2 }}>
        <CanAccess resource="merchants_offer_summaries" action="list">
          <MerchantsOfferSummaryWidget />
        </CanAccess>
      </Stack>
    </>
  );
}
